import Mock from 'mockjs'
import { save } from '@/mock/util'
import { dataItems } from '@/mock/net-sec/data'

const {page} = require('../util');

const qs = require('qs');
const {sendList, sendDataDetail} = require('./data');

Mock.mock('/datashare/list', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(sendList, bodyObject);
    bodyObject.total = sendList.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/datashare/detail', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(receiveDataDetail, bodyObject);
    bodyObject.total = receiveDataDetail.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/datashare/save', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    save(bodyObject, sendList);
    return {
        code: 200,
        body: sendList,
    }
});
